// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b9a06ab9","453":"a84d832a","622":"a30becbe"}[chunkId] + ".chunk.js";
};